import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "orgs-view container" }


import { storeToRefs } from 'pinia';
import { useOrgsStore } from '~store/orgs/orgsModule';
import structure from '@/views/orgsTableStructure.json';
import { Action, TableRow } from '@/components/TableComponent/types';
import { addZeros } from '~utils/stringHelpers';
import { actionHandler } from '@/actions/actionHandler';

const __default__ = { name: 'OrgsView' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  async setup(__props) {

let __temp: any, __restore: any


const orgStore = useOrgsStore();
const { fullOrgList, currentOrg } = storeToRefs(orgStore);

if (!fullOrgList.value.data) {
  (
  ([__temp,__restore] = _withAsyncContext(() => orgStore.getFullOrgList())),
  await __temp,
  __restore()
);
}

const newOrgAction: Action = {
  name: 'OrgEditorModal',
  type: 'modal',
  customParam: {
    maximized: true,
  },
};

const onAction = () => {
  actionHandler(newOrgAction);
};

const convertValue = (item: TableRow): TableRow => {
  const keys = Object.keys(item);
  const convertibleKeys = ['sum_act', 'summ_pay', 'debet', 'bill_without_act', 'debet_common'];
  keys.forEach((key) => {
    if (convertibleKeys.includes(key)) {
      // eslint-disable-next-line no-param-reassign
      item[key] = addZeros(item[key]);
    }
  });
  return item;
};


return (_ctx: any,_cache: any) => {
  const _component_TableComponent = _resolveComponent("TableComponent")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_page_sticky = _resolveComponent("q-page-sticky")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(fullOrgList).data)
          ? (_openBlock(), _createBlock(_component_TableComponent, {
              key: 0,
              tableId: "orgs-table",
              table: _unref(fullOrgList),
              useItems: [convertValue]
            }, null, 8, ["table", "useItems"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_q_page_sticky, {
      position: "bottom-right",
      offset: [18, 18]
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_btn, {
          fab: "",
          icon: "add",
          color: "accent",
          onClick: onAction
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})